import React, { forwardRef } from 'react';
import {
	ContextualAnalyticsData,
	AnalyticsEventToProps,
} from '@atlassian/jira-product-analytics-bridge';
import { fg } from '@atlassian/jira-feature-gating';
import { CONTEXT_MENU_CHILDREN_WRAPPER_TESTID } from './constants.tsx';
import type { ChildrenWrapperProps } from './types.tsx';

const WrapperWithAnalytics = AnalyticsEventToProps('contextMenu', {
	onContextMenu: 'opened',
	// @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
})(forwardRef(({ createAnalyticsEvent, ...props }, ref) => <div {...props} ref={ref} />));

const attributes = { inputSource: 'rightClick' };
export const ChildrenWrapperWithAnalytics = forwardRef(
	({ children, onChildrenContextMenu }: ChildrenWrapperProps, ref) => {
		const WrapperWithAnalyticsComponent = WrapperWithAnalytics;

		return (
			<ContextualAnalyticsData
				attributes={
					fg('jfp-magma-concurrent-board-perf-2') ? attributes : { inputSource: 'rightClick' }
				}
			>
				<WrapperWithAnalyticsComponent
					ref={ref}
					onContextMenu={onChildrenContextMenu}
					data-testid={CONTEXT_MENU_CHILDREN_WRAPPER_TESTID}
				>
					{children}
				</WrapperWithAnalyticsComponent>
			</ContextualAnalyticsData>
		);
	},
);
